<template>
  <div class="RoomCategory" v-if="show" :class="{
    loading: loading > 0,
    'select-room-type': viewChildren,
    'select-room-category': !viewChildren,
  }">
    <h2 class="title" v-if="!viewChildren">
      {{ tran("ROOM_CATEGORY_TITLE") }}
    </h2>
    <h2 class="title" v-else>
      {{ tran("ROOM_CATEGORY_TYPE_TITLE", { roomType: category.title }) }}
    </h2>
    <div class="items" :number-of-items="items.length">
      <div class="item" v-for="(item, index) in items" :key="index" :class="{
        selected:
          (!viewChildren && data.roomCategory == item.value) ||
          (viewChildren && data.roomCategoryType == item.value),
        unavailable: !categoryAvailable(item),
      }" :index="index" :code="item.value">
        <div class="wrapper">
          <div class="image pointer">
            <img @click.prevent="select(item)" v-if="item.image" :src="item.image"
              :disabled="categoryAvailable(item) ? null : ''" />
            <div class="view-gallery" @click.prevent="run('showGallery', item)"
              v-if="item.gallery && item.gallery.length">
              <span class="fa fa-images"></span><span v-html="tran('VIEW_GALLERY')"></span>
            </div>
          </div>
          <div v-if="item.guarantee" class="desc pointer" @click.prevent="(e) => select(item, e)"
            :disabled="categoryAvailable(item) ? null : ''">
            <h3 v-if="item.name" class="title" v-html="item.name"></h3>
            <h3 v-else class="title" v-html="item.title"></h3>
            <div v-if="categoryAvailable(item)" class="desc" v-html="item.description"></div>
            <div v-else class="desc unavailable-message" v-html="tran('CABIN_UNAVAILABLE_MESSAGE2')"></div>
            <div v-if="categoryAvailable(item)" class="price" v-html="item.from_price"></div>
          </div>
          <div v-else class="desc pointer" @click.prevent="(e) => select(item, e)"
            :disabled="categoryAvailable(item) ? null : ''">
            <h3 v-if="item.name" class="title" v-html="item.name"></h3>
            <h3 v-else class="title" v-html="item.title"></h3>
            <div v-if="categoryAvailable(item)" class="desc" v-html="item.description"></div>

            <div v-if="!categoryAvailable(item)" v-html="tran('CABIN_SOLD_OUT')" class="desc sold-out-message"></div>

            <div v-if="categoryAvailable(item)" class="price" v-html="item.from_price"></div>
          </div>
          <button v-if="item.callUs" id="room-call-us" type="button" class="btn btn-success" @click.prevent="callUs">
            {{ tran("SELECT_CONTINUE") }}
          </button>
          <button v-else-if="categoryAvailable(item)" :id="viewChildren ? 'room-type-click' : 'room-cate-click'"
            type="button" class="btn btn-success" @click.prevent="select(item)"
            :disabled="categoryAvailable(item) ? null : ''">
            {{
              tran(
                categoryAvailable(item) ? "SELECT_CONTINUE" : "ROOM_UNAVAILABLE"
              )
            }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RoomCategory",
  components: {},
  props: {
    run: Function,
  },
  data: function () {
    return {
      isShow: false,
      loading: 0,
      datas: [],
      items: [],
      category: null,
      categoryType: null,
      viewChildren: false,
    };
  },
  mounted: function () {
    this.run("set", "groupStep." + this.$.type.name, "select_room");
    if (typeof this.validate == "function") {
      this.run("set", "validates." + this.$.type.name, this.validate);
    }
    if (typeof this.next == "function") {
      this.run("set", "nexts." + this.$.type.name, this.next);
    }
    if (typeof this.prev == "function") {
      this.run("set", "prevs." + this.$.type.name, this.prev);
    }
    if (this.show) {
      this.onShow();
    }
  },
  watch: {
    show: function (n) {
      if (n) {
        this.onShow();
      } else {
        this.onHide();
      }
    },
  },

  computed: {
    show: function () {
      return this.run("currentStep") == this.$.type.name;
    },
    data() {
      return this.run("get", "data");
    },
    numberOfRoom() {
      return this.rooms.length;
    },
    rooms() {
      return this.run("rooms");
    },
  },
  methods: {
    categoryAvailable(cat) {
      if (!cat.available) {
        return false;
      }

      if (cat.children) {
        for (const c of cat.children) {
          if (this.categoryAvailable(c)) {
            return true;
          }
        }
        return false;
      }
      if (cat.guarantee) {
        return true;
      }
      const roomIndex = this.run("get", "currentUserRoomIndex");
      let count = 0;
      for (const index in this.rooms) {
        if (index == roomIndex) {
          continue;
        }
        const room = this.rooms[index];
        if (room.categoryType == cat.value) {
          count++;
        }
      }
      return count < cat.availableRegularCabins;
    },
    tran(key, replaces) {
      return this.run("tran", key, replaces);
    },
    onShow() {
      this.viewChildren = false;
      this.fetch();
    },
    onHide() { },
    next() {
      if (
        !this.viewChildren &&
        this.category &&
        this.category.children &&
        this.category.children.length > 1
      ) {
        this.items = this.category.children;
        this.viewChildren = true;
        this.run("scrollToView");
        return false;
      }
      if (
        !this.viewChildren &&
        this.category &&
        this.category.children &&
        this.category.children.length == 1
      ) {
        this.viewChildren = true;
        this.items = this.category.children;
        if (
          this.category.children[0].available &&
          !this.category.children[0].callUs
        ) {
          this.select(this.category.children[0]);
        } else {
          this.run("scrollToView");
        }
        return false;
      }
      return true;
    },
    prev() {
      console.log(this.run("get", "forceBackCategory"))
      if (this.run("get", "forceBackCategory") === true) {
        this.run("set", "forceBackCategory", false)
        return true;
      }
      if (this.viewChildren && this.datas.length > 1) {
        this.viewChildren = false;
        this.items = this.datas;
        return false;
      }
      return true;
    },
    async fetch() {
      if (this.viewChildren) {
        return;
      }
      // if (this.datas.length) {
      //   this.items = this.datas;
      //   return;
      // }
      this.loading++;
      const rooms = this.rooms;
      const numberOfRoom = this.run("numberOfRoom");
      const ship = this.run("get", "ship");
      const roomIndex = this.run("get", "currentUserRoomIndex");
      const room = rooms[roomIndex];
      const dataKey =
        "categoryData." +
        (room.numberOfAdults + "-" + room.numberOfChildren) +
        "-" +
        room.wheelchair +
        "-" +
        room.senior;
      let data = this.run("get", dataKey, false);
      if (!data || data.time < Date.now() - 30000) {
        const res = await this.run(
          "fetch",
          "index.php?option=com_cruise&task=" +
          this.run("get", "config.task", "booking") +
          ".getRoomCategories",
          {
            numberOfRoom,
            rooms,
            roomIndex,
            shipCode: ship.shipCode,
            packageId: ship.packageId,
            sailDate: ship.sailDate,
          }
        );
        if (!res.success) {
          this.run(
            "showMessage",
            res.message ?? "error",
            res.messageType,
            res.exitBooking,
            res.buttonLabel
          );
          this.loading--;
          return;
        }
        data = res.data;
        data.time = Date.now();
        this.run("set", dataKey, data);
      }

      this.datas = data.items;
      this.items = data.items;
      for (const cat of data.items) {
        for (const c of cat.children) {
          this.run("set", "roomCategories." + c.value, c);
        }
      }
      if (this.items.length == 1 && this.items[0].available) {
        this.select(this.items[0]);
      }
      this.loading--;
    },
    callUs() {
      this.run("popupAlert", this.tran("CALL_US_MESSAGE"), [
        {
          label: this.tran("CALL_US_BUTTON"),
          class: "btn-success",
          action: () => {
            document.location.href = "tel:" + this.tran("CALL_US_NUMBER");
          },
        },
        {
          label: this.tran("CANCEL"),
          class: "btn-warning",
          action: () => (this.modalData = ""),
        },
      ]);
    },
    select(item, event) {
      if (
        event &&
        event.target &&
        event.target.getAttribute("data-toggle") == "tooltip"
      ) {
        return;
      }
      if (item.callUs) {
        return this.callUs();
      }
      if (!this.categoryAvailable(item)) {
        return;
      }
      let value = item.value;
      const roomIndex = this.run("get", "currentUserRoomIndex");
      if (this.viewChildren) {
        this.categoryType = item;
        // this.run("set", "roomCategoryType", value);
        if (roomIndex == -1) {
          for (const room of this.run("get", "rooms")) {
            room.categoryType = value;
            room.categoryTitle = item.title;
          }
        } else {
          this.run("set", "rooms." + roomIndex + ".categoryType", value);
          this.run("set", "rooms." + roomIndex + ".categoryTitle", item.title);
          this.run("set", "rooms." + roomIndex + ".categoryPrice", item.price);
          this.run(
            "set",
            "rooms." + roomIndex + ".categoryPriceNumber",
            item.price_number
          );
          this.run("set", "rooms." + roomIndex + ".fareCode", item.fareCode);
          this.run("set", "rooms." + roomIndex + ".guarantee", item.guarantee);
          this.run("set", "rooms." + roomIndex + ".roomNumber", "");
          this.run("set", "rooms." + roomIndex + ".location", "");
          this.run("set", "rooms." + roomIndex + ".position", "");
          this.run("set", "rooms." + roomIndex + ".deckCode", "");
        }
      } else {
        this.category = item;
        // this.run("set", "roomCategory", value);
        if (roomIndex == -1) {
          for (const room of this.run("get", "rooms")) {
            room.category = value;
          }
        } else {
          this.run("set", "rooms." + roomIndex + ".category", value);
        }
      }
      this.run("set", "chooseRoom", true);
      this.run("next");
    },
    validate: function () {
      const rooms = this.run("rooms");
      for (const room of rooms) {
        if (!room.categoryType || !room.fareCode) {
          return false;
        }
      }
      return true;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
